import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { QuestionApiResponse } from 'types/Questions.types';
import useWindowWidth from 'utils/useWindowWidth';
import Card from 'components/Card';
import Banner from 'views/QuestionsWithCategories/components/Banners';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import { configuratorContext } from 'context/ConfiguratorContext';
import VKAd from '../VKAd';
import styles from './QuestionsList.module.css';

type QuestionsListProps = {
  data: QuestionApiResponse;
  banner?: {
    horizontalBannerPosition: number;
    eventInfo: string;
  } | null;
};

const QuestionsList = ({ data, banner }: QuestionsListProps) => {
  const router = useRouter();
  const deviceWidth = useWindowWidth();
  const { banners } = useContext(configuratorContext);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const itsLastPage = data?.totalPages && currentPage === data.totalPages;

  const showMobileBanner = deviceWidth < 1024 && deviceWidth > 0;

  useEffect(() => {
    if (
      router?.query?.page &&
      +router?.query?.page &&
      +router?.query?.page !== currentPage
    ) {
      setCurrentPage(+router?.query?.page);
    } else {
      setCurrentPage(1);
    }
  }, [router]);

  useEffect(() => {
    if (
      router?.query?.page &&
      +router?.query?.page &&
      +router?.query?.page !== currentPage
    ) {
      setCurrentPage(+router?.query?.page);
    } else {
      setCurrentPage(1);
    }
  }, [router]);

  const nextPageBtnHandler = () => {
    router.push({
      query: { ...router.query, page: currentPage + 1 },
    });
  };

  return (
    <div className={styles.qustions}>
      {data?.questions &&
        data.questions.map((i, index) => (
          <div key={i.slug}>
            <Card
              body={i.body}
              publishedAnswersCount={i.publishedAnswersCount}
              category={i.category}
              grade={i.grade}
              slug={i.slug}
              authorAvatar={i.authorAvatar}
              updatedAt={i.updatedAt}
            />
            {banner?.horizontalBannerPosition === index &&
              showMobileBanner &&
              banners?.otvety_side_banners && (
                <Banner
                  width={256}
                  height={160}
                  linkFromBanner={banners?.otvety_side_banners?.link}
                  imageUrl={banners?.otvety_side_banners?.images?.mobile}
                  backgroundColor={banners?.otvety_side_banners?.background}
                  bannerType="mobile"
                  eventInfo={banner.eventInfo}
                  className={styles.mobile_banner}
                  bannerName={banners?.otvety_side_banners?.name}
                />
              )}
            {banner?.horizontalBannerPosition === index &&
              banners?.otvety_side_banners === null &&
              showMobileBanner && (
                <VKAd
                  slotId="1531134"
                  maxWidth="100%"
                  maxHeight="250px"
                  className={styles.ad_wrapper}
                />
              )}
          </div>
        ))}
      {!itsLastPage && (
        <Button
          type="default"
          className={styles.button_next_page}
          text="Дальше"
          onClick={nextPageBtnHandler}
        />
      )}
      {data?.totalPages && (
        <Pagination
          currentPage={currentPage}
          total={data.totalPages}
          className={styles.pagination_categories}
        />
      )}
    </div>
  );
};

export default QuestionsList;
